import "./DaShell.css";
import PropTypes from "prop-types";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { useAppTheme } from "../../theme/useTheme";

const DaShell = ({ children }) => {
  const theme = useAppTheme();
  return (
    <div className="da-shell-wrapper">
      <div className="da-header"> {theme?.assets?.logo && <img src={theme.assets.logo} alt="Worldline logo" />} </div>

      <div className="da-shell-bg">{children}</div>

      <footer className="da-footer">
        <span className="da-footer-text">
          <Translate tKey={T_KEYS.DA.SHELL.COPYRIGHT} />
        </span>
        <a href="#" className="da-footer-text">
          <Translate tKey={T_KEYS.DA.SHELL.PRIVACY} />
        </a>
        <a href="#" className="da-footer-text">
          <Translate tKey={T_KEYS.DA.SHELL.TERMS} />
        </a>
      </footer>
    </div>
  );
};

DaShell.propTypes = {
  children: PropTypes.node,
};

export { DaShell };
